import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";

// Admin dashboard typography
import "@fontsource/chivo/400.css";
import "@fontsource/chivo/600.css";
import "@fontsource/chivo/700.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";

import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
